import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { WorkflowSchemeReportsData } from './WorkflowSchemeReportsData.types.tsx';

const RESOURCE_TYPE_WORKFLOW_SCHEME_PROJECTS_LIMITS = 'WORKFLOW_SCHEME_PROJECTS_LIMITS';

export const workflowSchemeProjectsLimitsResource: RouteResource<WorkflowSchemeReportsData> =
	createResource<WorkflowSchemeReportsData>({
		type: RESOURCE_TYPE_WORKFLOW_SCHEME_PROJECTS_LIMITS,
		getKey: () => 'workflowSchemeProjectsLimits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-workflow-scheme-projects-limits", jiraSpaEntry: "async-resource-workflow-scheme-projects-limits" */ './getWorkflowSchemeData.tsx'
			),
	});
